const { itemFetcherToArrayGetter, genericGetter } = require("./utilities")
const { gql } = require("@apollo/client")

const DataLoader = require("dataloader")

function batchPropGetter(obj) {
  return async function (keys) {
    const response = await obj.client.query({
      query: gql`
            {
                pendingShare(id:"${obj.id}"){
                    id
                    ${keys.join("\n")}
                }
            }
        `,
    })

    const fetchedValues = keys.map((key) => response.data.pendingShare[key])

    return fetchedValues
  }
}

class PendingShare {
  constructor(client, id) {
    this.client = client
    this.id = id
    this.propLoader = new DataLoader(batchPropGetter(this))
  }

  static fields() {
    return [
      "id",
      "createdAt",
      "updatedAt",
      "sender",
      "receiver",
      "role",
      "environment",
    ]
  }

  get createdAt() {
    return this.propLoader.load("createdAt")
  }

  get updatedAt() {
    return this.propLoader.load("updatedAt")
  }

  get role() {
    return this.propLoader.load("role")
  }
}

const getPendingShare = genericGetter(
  async (index) =>
    gql(`
{
    user {
        id
        pendingShares(offset:${index},limit:1){
            id
        }
    }
}
`),
  "user.pendingShares",
  PendingShare
)

module.exports = { PendingShare, getPendingShare }
